import { useAnalytics } from '@/services/analytics';
import { useAuth } from '@/services/auth';
import { AppRoutes, MixPanelEvent } from '@/utils/types';
import { useNavigate } from 'react-router-dom';

export const useCreateAvatarRedirect = () => {
    const { isAnonymous, loginWithRedirect } = useAuth();
    const mixpanel = useAnalytics();
    const navigate = useNavigate();

    const onClick = ({ from, fromPath }: { from?: string; fromPath?: string }) => {
        if (isAnonymous) {
            mixpanel?.track('go-to-signup', { event: MixPanelEvent.CLICK, from: 'create-box', isAnonymous });
            loginWithRedirect({ appState: { returnTo: window.location.origin + AppRoutes.PostSso } });
        } else {
            navigate(AppRoutes.AvatarsCreate, { state: { from, fromPath } });
        }
    };

    return { onClick };
};
